import React from 'react'
import NumberFormat from 'react-number-format'

export default function NumberFormatCustom(props) {
  const {...other} = props

  return <NumberFormat thousandSeparator decimalScale={2} isNumericString={true} {...other} />
}
